class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  close() {
    // Collapse any nested level too, so the menu reopens in its resting state
    // instead of remembering that Prints was left expanded.
    this.querySelectorAll('.header__submenu details[open]').forEach((d) => {
      d.open = false;
    });
    super.close();
  }

  onToggle() {
    // Close the other top-level menus the moment this one opens.
    //
    // Stock Dawn only closes a menu on `focusout`, which a pointer hover never
    // fires. Measured on DawnB 2026-09-15b: hovering Shop and then moving to
    // About left BOTH panels open and overlapping by 129px -- About painted on
    // top of Shop, with Shop's links still live and clickable underneath. That
    // is the overlap Shane reported when moving from Shop to About.
    //
    // Nested submenus (the third level, e.g. Prints) are plain <details>, not
    // <header-menu>, so they are deliberately not matched here and continue to
    // open and close inside their parent as before.
    //
    // No recursion risk: close() clears `open`, which fires `toggle` again on
    // that sibling, but this block is guarded on the menu being open.
    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.open) menu.close();
      });
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Nested submenus (the third level, e.g. Shop > Prints > Sky Study) open on hover,
// so they behave like the top level instead of demanding a click. Shane, 2026-09-17:
// "once a person scrolls down to prints the subsection automatically drops. like
// the main menu does."
//
// Deliberately NO mouseleave handler. The panels sit 1.4rem below the header and
// that gap belongs to no DOM element, so a mouseleave fires while the pointer is
// crossing it on the way in -- which slams the menu shut before you arrive. Tested
// 2026-09-17: that is exactly what happened on the first attempt. Nested levels are
// reset in HeaderMenu.close() above instead.
function initNestedMenuHover() {
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  nav.addEventListener('mouseover', (event) => {
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    if (!details.closest('.header__submenu')) return; // nested levels only
    if (!details.open) details.open = true;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNestedMenuHover);
} else {
  initNestedMenuHover();
}
